import React, {useState} from "react";
import {FiArrowLeft, FiChevronDown} from "react-icons/fi";
import { MdOutlineLaunch } from "react-icons/md";
import { FcDocument } from "react-icons/fc";
import Card from "../Base/Card";
import ProcessProgressStage from "./ProcessProgressStage";

interface PropsI {
    onBack: ()=>void
    onClose: ()=>void
}

const RSAPreview = ({ onClose, onBack }: PropsI)=>{
    const [showProcessProgress, setShowProcessProgress] = useState(true);

    const toggleShowProcessModal = ()=> setShowProcessProgress(!showProcessProgress);

    return (
        <div className="rsa_preview_component">
            <ProcessProgressStage showModal={showProcessProgress} onClose={toggleShowProcessModal} />
            <div className="flex justify-between">
                <button className="btn btn-outline" onClick={onBack}>
                    <FiArrowLeft />  Back
                </button>
                <button className="btn btn-primary">
                    Action <FiChevronDown />
                </button>
            </div>
            <Card className="my-6">
                <div className="h1">
                    Preview RSA Transfer Details
                </div>
                <Card className="mb-6 bg-grayscaleBG">
                    <div className="section-card">
                        <div  className="mt-8 min-w-[250px]">
                            Process Information
                        </div>
                        <table className="info">
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Initiated By:
                                        </div>
                                        <div className="info__group--text">
                                            Matthew Fawibe
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Process Type:
                                        </div>
                                        <div className="info__group--text">
                                            Asset Acquisition
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Date Initiated:
                                        </div>
                                        <div className="info__group--text">
                                            04 Jan 2023, 02:25:21
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Levels of Approval
                                        </div>
                                        <div className="info__group--text">
                                            3
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Process Status:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Processing
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <button className="btn btn-outline" onClick={toggleShowProcessModal}>
                                        Preview Stage <MdOutlineLaunch className="ml-2" />
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Card>
                <Card className="mb-6 bg-grayscaleBG">
                    <div className="section-card">
                        <div className="mt-8 min-w-[250px]">
                            Personal Information
                        </div>
                        <table className="info">
                            <tr className="info__row">
                                <td >
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            First Name:
                                        </div>
                                        <div className="info__group--text">
                                        Nil
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Middle Name:
                                        </div>
                                        <div className="info__group--text">
                                        Nil
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Last Name:
                                        </div>
                                        <div className="info__group--text">
                                        Nil
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Title:
                                        </div>
                                        <div className="info__group--text">
                                            3
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Gender:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Processing
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Date of Birth:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Jul 11th, 1990
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Apartment Suite Number:
                                        </div>
                                        <div className="info__group--text">
                                            16B
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Street Address:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Ajao close
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            City:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Surulere
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            State:
                                        </div>
                                        <div className="info__group--text">
                                            Lagos
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Phone Number:
                                        </div>
                                        <div className="info__group--text text-primary">
                                        Nil
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Email Address:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Nil
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Card>
                <Card className="mb-6 bg-grayscaleBG">
                    <div className="section-card">
                        <div  className="mt-8 min-w-[250px]">
                            RSA Information
                        </div>
                        <table className="info">
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Legal Company Name:
                                        </div>
                                        <div className="info__group--text">
                                            NLPC PENSION FUND ADMINISTRATO...
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Resident PFA:
                                        </div>
                                        <div className="info__group--text">
                                            NPF Pension Limited
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Recapture Status:
                                        </div>
                                        <div className="info__group--text">
                                            Recaptured
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            RSA Location:
                                        </div>
                                        <div className="info__group--text">
                                            Lagos
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            RSA Status:
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Micro Pension
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Remarks
                                        </div>
                                        <div className="info__group--text text-primary">
                                            Nil
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Card>
                <Card className="mb-6 bg-grayscaleBG">
                    <div className="section-card">
                        <div  className="mt-8 min-w-[250px]">
                            Additional Information
                        </div>
                        <table className="info">
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            Legal Company Name:
                                        </div>
                                        <div className="info__group--text">
                                            NLPC PENSION FUND ADMINISTRATO...
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Card>
                <Card className="mb-6 bg-grayscaleBG">
                    <div className="section-card">
                        <div  className="mt-8 min-w-[250px] min-w-[250px]">
                            Other Information
                        </div>
                        <table className="info">
                            <tr className="info__row">
                                <td>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            CAC registration cert.
                                        </div>
                                        <div className="info__group--text flex items-center">
                                            <span className="text-xl mr-1"><FcDocument /> </span>
                                            GalaxoSmilth_cac_cert.pdf
                                        </div>
                                    </div>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            CAC registration cert.
                                        </div>
                                        <div className="info__group--text flex items-center">
                                            <span className="text-xl mr-1"><FcDocument /> </span>
                                            GalaxoSmilth_memart_cert.pdf
                                        </div>
                                    </div>
                                    <div className="info__group">
                                        <div className="info__group--label">
                                            CAC registration cert.
                                        </div>
                                        <div className="info__group--text flex items-center">
                                            <span className="text-xl mr-1"><FcDocument /> </span>
                                            GalaxoSmilth_tin_document.pdf
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Card>
                <div className="flex justify-end">
                    <button className="btn btn-outline btn-b mr-4">
                        Edit
                    </button>
                    <button className="btn btn-primary btn-b mr-4">
                        Approve
                    </button>
                    <button className="btn btn-danger btn-b">
                        Decline
                    </button>
                </div>
            </Card>
        </div>
    )
}
export default RSAPreview;